import { render, staticRenderFns } from "./DayProfit.vue?vue&type=template&id=e52b49be&scoped=true&"
import script from "./DayProfit.vue?vue&type=script&lang=js&"
export * from "./DayProfit.vue?vue&type=script&lang=js&"
import style0 from "./DayProfit.vue?vue&type=style&index=0&id=e52b49be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e52b49be",
  null
  
)

export default component.exports